// extracted by mini-css-extract-plugin
module.exports = {"container":"Queries_container__3e_Um","queries":"Queries_queries__2BqPX","buttonCreateQuery":"Queries_buttonCreateQuery__2wEJu"};